import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import Select from "react-select"; 
// FeatherIcon from "feather-icons-react";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider, FieldArray } from "formik";
import { loader_image } from "../_components/Imagepath";
import {  Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import  "./../assets/css/custom.css";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
// import { useDropzone } from "react-dropzone";
import Cropper from "react-easy-crop";
import Slider from "@mui/material/Slider";
import Button from "@mui/material/Button";
// import Alert from "@mui/material/Alert";
// import "@pqina/pintura/pintura.css";
import DropzoneComponent from "./DropzoneComponent"; // Import the custom Dropzone
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

const QualityReportsAdd = () => {
  const [ordersLists, setOrdersLists] = useState([]);
  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
 // IMAGE HANDLING STATES
 const [images, setImages] = useState([]);
 const [currentImageIndex, setCurrentImageIndex] = useState(0);
 const [crop, setCrop] = useState({ x: 0, y: 0 });
 const [zoom, setZoom] = useState(1);
 const [rotation, setRotation] = useState(0);
 const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
 const [productionbarcodes, setProductionbarcodes] = useState([]);
//  const [error, setError] = useState(null);
const [showCropper, setShowCropper] = useState(false);
const [permission, setPermission] = useState({});
// const [currentbarcodeArr, setCurrentbarcodeArr] = useState([]);

  //const [files, setFiles] = useState<FilePondFile[]>([]);
  // const [files, setFiles] = useState([]);
    let season_id = localStorage.getItem("season_id");


  // const generateToken = () => {
  //   const array = new Uint8Array(16); // 16 bytes = 128-bit token
  //   crypto.getRandomValues(array);
  //   return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
  // };
  const formik = useFormik({
    initialValues: {
      id: 0,
      season_id:season_id,
      order: "",
      sender: "Export Optimum SARL",
      customer: "",
      transport: "",
      transport_number: "",
      product: "",
      ref: "",
      date: "",
      pallets: [
        {
          product: "",
          temperature: "",
          size: "",
          sample_weight: "",
          class: "",
          box_net_weight: "",
          packaging: "",
          lot_number: "",
          number_of_boxes: "",
          palletesation: "",
          country: "Morocco",
          label_conformity: "",
          token_number: Math.floor(Math.random() * 10000000000),
          pictures: [],
        },
      ],
    },
    onSubmit: (values, { setSubmitting }) => {
    // console.log("Form submitted with values: ", values); // Check if form submission triggers

     const pallets12 = values.pallets.slice(-1);
    // console.log(pallets12);

     values.pallets = pallets12;
     //console.log(values);


    // return false;
      axios
        .post("/quality-report/add", values, {
          headers: { 
            Authorization: `Bearer ${Authtoken}`, 
            Apitoken: Apitoken,
          //  'Content-Type': 'multipart/form-data', // Important!

          },
        })
        .then((response) => {
          $("#form-submit").text("Add Production Output");
          if (response.data.code === 200) {
            const report_id = response.data.data.report.id;
            axios
              .get(`/quality-report/pdf/${season_id+'-'+report_id}`, {
                responseType: "blob",
                headers: {
                  Authorization: `Bearer ${Authtoken}`,
                  Apitoken: Apitoken,
                },
              })
              .then((response) => {
                const blob = new Blob([response.data], {
                  type: "application/pdf",
                });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "Quality Report.pdf";
                link.click();
              })
              .catch((error) => console.error("Error downloading PDF:", error));
            setSubmitting(false);
            toast.success(response.data.message);
           // setBackendSuccess(response.data.message);
            setTimeout(() => {
              window.location.href = "/quality-reports";
            }, 1000);
          } else {
            setBackendErrors(response.data.error);
            setSubmitting(false);
          }
        })
        .catch((error) => {
          toast.error(error.message);
        });
    },
  });


  useEffect(() => {
        setPermission(FindModuleById(447)); 
    console.log(permission);
    let para ={season_id:season_id};
    axios
    .post("/orders-quality-report/listing-shipped-delivered", para,  {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    })
    .then((response) => {
      if (response.data.code === 200) {
        let orders = response.data.data.orders;

        let orderlisting = orders.map((ord, index) => ({
          label: ord.po_number,
          value: ord.id,
          key: `order-${index}`,
        }));
        setOrdersLists(orderlisting);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });
  }, []);

  const getQualityReportData = (event) => {
  

    const order_id = event.value;
    if(order_id !=''){
      console.log(event);
      axios
      .get(`/orders/get-quality-reports/${season_id+'-'+order_id}`,  {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let quality_data = response.data.data.quality;
        //  console.log(quality_data);

            // Use setFieldValue to update the customer and other fields
                formik.setFieldValue('customer', quality_data.customer);
                formik.setFieldValue('transport', quality_data.transport);
                formik.setFieldValue('transport_number', quality_data.transport_number);
                formik.setFieldValue('product', quality_data.product);
                formik.setFieldValue('ref', quality_data.ref);
                formik.setFieldValue('date', quality_data.date);


                let orders = response.data.data.productions;
                  let orderlisting = orders.map((ord, index) => ({
                    label: ord.barcode_number,
                    value: ord.barcode_number,
                    lot_number: ord.lot_number_total,
                    key: `order-${index}`,
                  }));
                setProductionbarcodes(orderlisting);
                

              } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
  }
  // const toggleMobileMenu = () => {
  //   setMenu(!menu);
  // };
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Converts file to Base64
      reader.onload = () => resolve(reader.result); // Base64 string
      reader.onerror = (error) => reject(error);
    });
  };

const onDrop = useCallback(
  async (acceptedFiles, palletIndex) => {
    const filesArray = Array.from(acceptedFiles);
    const currentPictures = formik.values.pallets[palletIndex]?.pictures || [];

    try {
      const resizedImages = await Promise.all(
        filesArray.map(async (file) => {
          const base64Image = await fileToBase64(file);
          return resizeImage(base64Image, 1000, 1000); // Resize to 65mm x 65mm (approx. 246px x 246px)
        })
      );

      let updatedPictures = [...currentPictures, ...resizedImages];
      if (updatedPictures.length > 6) {
        updatedPictures.length = 6;
      }

    

        // Update Formik's state for the specific pallet
        formik.setFieldValue(`pallets[${palletIndex}].pictures`, updatedPictures);

        // Use a function inside setImages to ensure the previous state is maintained
        setImages((prevImages) => {
          const newImages = Array.isArray(prevImages) ? [...prevImages] : [];
          newImages[palletIndex] = updatedPictures;
          return newImages;
        });
    } catch (error) {
      console.error("Error resizing images:", error);
    }
  },
  [formik]
);


const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
  setCroppedAreaPixels(croppedAreaPixels);
}, []);


const resizeImage = (base64Str, maxWidth, maxHeight) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64Str;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      let { width, height } = img;

      // Calculate the new dimensions while maintaining aspect ratio
      if (width > maxWidth || height > maxHeight) {
        if (width > height) {
          height = (maxHeight / width) * height;
          width = maxWidth;
        } else {
          width = (maxWidth / height) * width;
          height = maxHeight;
        }
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);

      resolve(canvas.toDataURL("image/jpeg"));
    };
  });
};


const getCroppedImage = async (imageSrc) => {
  const image = new Image();
  image.src = imageSrc;

  return new Promise((resolve, reject) => {
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // Set canvas size to the cropped area resolution
      const scaleX = image.naturalWidth / image.width; // Adjust for potential scaling
      const scaleY = image.naturalHeight / image.height;

      const croppedWidth = croppedAreaPixels.width * scaleX;
      const croppedHeight = croppedAreaPixels.height * scaleY;

      canvas.width = croppedWidth;
      canvas.height = croppedHeight;

      // Apply rotation and cropping
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate((rotation * Math.PI) / 180);
      ctx.translate(-canvas.width / 2, -canvas.height / 2);

      ctx.drawImage(
        image,
        croppedAreaPixels.x * scaleX,
        croppedAreaPixels.y * scaleY,
        croppedWidth,
        croppedHeight,
        0,
        0,
        canvas.width,
        canvas.height
      );

      // Export as a high-quality image
      const base64Image = canvas.toDataURL("image/jpeg", 1.0); // 95% quality
      resolve(base64Image);
    };

    image.onerror = (err) => reject(err);
  });
};


  
const handleSaveCroppedImage = async (palletIndex, imgIndex) => {
  //setLoading(true);
  try {
    const croppedImageUrl = await getCroppedImage(
      images[palletIndex][imgIndex]
    );
    const updatedImages = [...formik.values.pallets[palletIndex].pictures];
    updatedImages[imgIndex] = croppedImageUrl;
    formik.setFieldValue(`pallets[${palletIndex}].pictures`, updatedImages);

    // setImages((prev) => ({
    //   ...prev,
    //   [palletIndex]: updatedImages,
    // }));
    setImages((prevImages) => {
      const newImages = [...prevImages]; // Create a shallow copy of the outer array
      newImages[palletIndex] = [...newImages[palletIndex]]; // Create a shallow copy of the specific pallet's images
      newImages[palletIndex][imgIndex] = croppedImageUrl; // Update the specific image
      return newImages; // Return the updated array
    });
  } catch (error) {
    console.error("Error saving cropped image:", error);
  } finally {
    //setLoading(false);
  }

  setShowCropper(false);
};
  
      


 

      const handleDeleteImage = (palletIndex, imgIndex) => {
        // Get a deep copy of the current state of pallets' pictures
        const updatedPallets = [...formik.values.pallets];
      
        // Ensure that we're working on a copy of the specific pallet's pictures array
        const currentPictures = [...(updatedPallets[palletIndex]?.pictures || [])];
      
       
      
        // Remove the image from the local state
        if (currentPictures.length > imgIndex) {
          currentPictures.splice(imgIndex, 1); // Remove the image at imgIndex
        }
      
        // Update the specific pallet's pictures in the deep copy of the formik state
        updatedPallets[palletIndex].pictures = currentPictures;
      
        // Update formik's state with the modified copy
        formik.setFieldValue(`pallets`, updatedPallets);
      
        // Update the images state to reflect the change locally (for rendering)
        setImages((prevImages) => {
          const newImages = [...prevImages];
          newImages[palletIndex] = currentPictures;
          return newImages;
        });
      
        // Update currentImageIndex if necessary to prevent out-of-bounds issues
        if (imgIndex === currentImageIndex) {
          setCurrentImageIndex(Math.max(0, imgIndex - 1));
        }
      };


 

  

  // const handleImageClick = (imgIndex) => {
  //   setCurrentImageIndex(imgIndex);
  //   setShowCropper(true); // Show the cropper container when an image is clicked
  // };
  const [activePalletIndex, setActivePalletIndex] = useState(null);

  const handleImageClick = (palletIndex, imgIndex) => {
    setCurrentImageIndex(imgIndex);
    setActivePalletIndex(palletIndex); // Set the active pallet index to show the cropper for that pallet
    setShowCropper(true);
  };


  const handleMoveImage = (palletIndex, imgIndex, direction) => {
    // Create a copy of the current pallet's images
    const updatedImages = [...images[palletIndex]];
  
    // Swap the current image with the one in the direction
    const swapIndex = imgIndex + direction;
    [updatedImages[imgIndex], updatedImages[swapIndex]] = [
      updatedImages[swapIndex],
      updatedImages[imgIndex],
    ];
  
    // Update the images state
    setImages((prev) => {
      const newImages = [...prev];
      newImages[palletIndex] = updatedImages;
      return newImages;
    });
  
    // Update Formik state
    formik.setFieldValue(`pallets[${palletIndex}].pictures`, updatedImages);
  };
  


  const deleteItemFromDB = async (item_id) => {
    const response_data = { status: 'false' };
    // Show a confirmation alert
    const isConfirmed = window.confirm("Are you sure you want to delete this pallet?");
    if (!isConfirmed) {
      // If the user cancels the deletion, just return
      return response_data;
    }
    try {
      // Proceed with deletion if the user confirmed
      const response = await axios.get(`/quality-report/pallet-token/delete/${season_id+'-'+item_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      });
      if (response.data.code === 200) {
        response_data.status = 'ok';
        //alert("Pallet deleted successfully!"); // Show a success message after deletion
      } else {
        alert("Failed to delete the pallet. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting the pallet:", error);
      alert("Error occurred while deleting the pallet.");
    }
    return response_data;
  };


  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
//  console.log(images);

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => setMenu(!menu)} />
      <Sidebar />  <ToastContainer />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Quality Report</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/quality-reports">Quality Report</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Quality Report</li>
                </ul>
              </div>
            </div>
          </div>
          {permission && permission.add == 1 && (

          <FormikProvider value={formik}>
            <form action="#" onSubmit={formik.handleSubmit}>
              {/* Additional fields and pallets */}
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group status">
                    <label>Order PO Number</label>
                    <Select
                     className="w-100"
                     value={ordersLists.find(option => option.value == formik.values.order) || null} // Ensure correct format
                     name="order"
                       //onChange={(selectedOption) => handleSelectChange("order", selectedOption);     getQualityReportData(selectedOption)}
                       onChange={(selectedOption) => {
                        handleSelectChange("order", selectedOption); 
                        getQualityReportData(selectedOption)
                      }}
                     onBlur={formik.handleBlur}
                     options={ordersLists}
                     placeholder="Select"


                     
                    />

                    <small>
                      {backendErrors.order && (
                        <span order="form-error mt-1">
                          {backendErrors.order}
                        </span>
                      )}
                    </small>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label>Sender </label>
                    <input
                      type="text"
                      name="sender"
                      value={formik.values.sender}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <small>
                      {backendErrors.sender && (
                        <span className="form-error mt-1">
                          {backendErrors.sender}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Customer </label>
                    <input
                      type="text"
                      name="customer"
                      value={formik.values.customer}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <small>
                      {backendErrors.customer && (
                        <span className="form-error mt-1">
                          {backendErrors.customer}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Transport </label>
                    <input
                      type="text"
                      name="transport"
                      value={formik.values.transport}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <small>
                      {backendErrors.transport && (
                        <span className="form-error mt-1">
                          {backendErrors.transport}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Transport Number </label>
                    <input
                      type="text"
                      name="transport_number"
                      value={formik.values.transport_number}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <small>
                      {backendErrors.transport_number && (
                        <span className="form-error mt-1">
                          {backendErrors.transport_number}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Product </label>
                    <input
                      type="text"
                      name="product"
                      value={formik.values.product}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <small>
                      {backendErrors.product && (
                        <span className="form-error mt-1">
                          {backendErrors.product}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>REF </label>
                    <input
                      type="text"
                      name="ref"
                      value={formik.values.ref}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <small>
                      {backendErrors.ref && (
                        <span className="form-error mt-1">
                          {backendErrors.ref}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Date </label>
                    <input
                      type="date"
                      name="date"
                      value={formik.values.date}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <small>
                      {backendErrors.date && (
                        <span className="form-error mt-1">
                          {backendErrors.date}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <h3 className="card-title">
                    <br />
                    Pallets
                  </h3>
                </div>
              </div>

              <FieldArray
                name="pallets"
                render={(arrayHelpers) => (
                  <div>
                    {/* <button
                      className="btn btn-primary mb-3"
                      type="button"
                      onClick={() => {
                        let appendArr = arrayHelpers.form.values.pallets[0];
                        let appendArr_1 = arrayHelpers.form.values.pallets && arrayHelpers.form.values.pallets[0];

                        let product_name = (appendArr_1 && appendArr_1.product) ? appendArr_1.product : "";
                        let temperature_name = (appendArr_1 && appendArr_1.temperature) ? appendArr_1.temperature : "";
                        let size_name = (appendArr_1 && appendArr_1.size) ? appendArr_1.size : "";
                        let sample_weight_name = (appendArr_1 && appendArr_1.sample_weight) ? appendArr_1.sample_weight : "";
                        let class_name = (appendArr_1 && appendArr_1.class) ? appendArr_1.class : "";
                        let box_net_weight_name = (appendArr_1 && appendArr_1.box_net_weight) ? appendArr_1.box_net_weight : "";
                        
                        let packaging_name = (appendArr_1 && appendArr_1.packaging) ? appendArr_1.packaging : "";
                        let lot_number_name = (appendArr_1 && appendArr_1.lot_number) ? appendArr_1.lot_number : "";
                        let number_of_boxes_name = (appendArr_1 && appendArr_1.number_of_boxes) ? appendArr_1.number_of_boxes : "";
                        let palletesation_name = (appendArr_1 && appendArr_1.palletesation) ? appendArr_1.palletesation : "";
                        let country_name = (appendArr_1 && appendArr_1.country) ? appendArr_1.country : "";
                        let label_conformity_name = (appendArr_1 && appendArr_1.label_conformity) ? appendArr_1.label_conformity : "";
                                     
                        let initialArr = {
                          product:product_name,
                          temperature: temperature_name,
                          size: size_name,
                          sample_weight: sample_weight_name,
                          class: class_name,
                          box_net_weight: box_net_weight_name,

                          packaging: packaging_name,
                          lot_number: lot_number_name,
                          number_of_boxes: number_of_boxes_name,
                          palletesation: palletesation_name,
                          country: country_name,
                          label_conformity: label_conformity_name,
                          pictures:[]
                        };
                          console.log('Submit button here ');

                       // appendArr = appendArr ? appendArr : initialArr;
                        arrayHelpers.push(initialArr);
                        //setShowTableHeadings(true);
                      }}
                    >
                      +
                    </button> */}
                    {formik.values.pallets.map((item, palletIndex) => {
                      // Collect all selected barcodes
                      const selectedBarcodes = formik.values.pallets
                        .map((p) => p.pallet_barcode)
                        .filter(Boolean);

                      // Filter options for this pallet
                      const availableOptions = productionbarcodes.filter(
                        (opt) =>
                          !selectedBarcodes.includes(opt.value) || // not selected elsewhere
                          opt.value === formik.values.pallets[palletIndex].pallet_barcode // keep my current value
                      );
                      return(
                         <div key={palletIndex}>
                        <div className="row">
                          <div className="col-md-12" style={{fontSize:'24px'}}>Pallet# {palletIndex + 1}</div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Product/Variety </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].product`}
                                value={formik.values.pallets[palletIndex].product}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Temperature ° </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].temperature`}
                                value={
                                  formik.values.pallets[palletIndex].temperature
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Size </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].size`}
                                value={formik.values.pallets[palletIndex].size}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Sample weight (g) </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].sample_weight`}
                                value={
                                  formik.values.pallets[palletIndex].sample_weight
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Class </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].class`}
                                value={formik.values.pallets[palletIndex].class}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Box net weight (g) </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].box_net_weight`}
                                value={
                                  formik.values.pallets[palletIndex].box_net_weight
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Packaging </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].packaging`}
                                value={formik.values.pallets[palletIndex].packaging}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Lot number </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].lot_number`}
                                value={formik.values.pallets[palletIndex].lot_number}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Number of boxes </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].number_of_boxes`}
                                value={
                                  formik.values.pallets[palletIndex].number_of_boxes
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Palletesation </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].palletesation`}
                                value={
                                  formik.values.pallets[palletIndex].palletesation
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>


                            
                         
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Pallet Barcode Number  </label>
                            
                                      <Select
                                      key={palletIndex}
                                      name={`pallets[${palletIndex}].pallet_barcode`}
                                      options={availableOptions}
                                      value={
                                        availableOptions.find(
                                          (option) =>
                                            option.value === formik.values.pallets[palletIndex].pallet_barcode
                                        ) || null
                                      }
                                      onChange={(selectedOption) => {
                                        formik.setFieldValue(
                                          `pallets[${palletIndex}].pallet_barcode`,
                                          selectedOption.value
                                        );
                                        // ✅ Auto-fill lot_number here
                                        formik.setFieldValue(
                                          `pallets[${palletIndex}].lot_number`,
                                          selectedOption.lot_number || ""
                                        );
                                        customHandleInput({
                                          target: {
                                            name: `pallets[${palletIndex}].pallet_barcode`,
                                            value: selectedOption.value,
                                          },
                                        });
                                      }}
                                      onBlur={formik.handleBlur}
                                      placeholder="Select"
                                      className="w-100"
                                    />

                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                              <label>Country of origin </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].country`}
                                value={formik.values.pallets[palletIndex].country}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                          </div>
                          <div className="col-md-5">
                            <div className="form-group status">
                              <label>Label conformity </label>
                              <input
                                type="text"
                                className={`form-input form-control`}
                                name={`pallets[${palletIndex}].label_conformity`}
                                value={
                                  formik.values.pallets[palletIndex].label_conformity
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                              
                              <input
                                type="hidden"
                                name={`pallets[${palletIndex}].token_number`}
                                value={
                                  formik.values.pallets[palletIndex].token_number
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />

                            </div>
                          </div>

                          <div className="col-md-11">
                          <DropzoneComponent
                          palletIndex={palletIndex}
                          onDrop={onDrop} // Pass onDrop as a prop
                        />
                  <div
                    style={{
                      display: "flex",
                      marginTop: "20px",
                      flexWrap: "wrap",
                    }}
                  >
                    {images[palletIndex]?.map((image, imgIndex) => (
                      <div
                        key={imgIndex}
                        style={{
                          position: "relative",
                          margin: "10px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={image}
                          alt={`preview ${imgIndex}`}
                          style={{
                            width: "150px",
                            cursor: "pointer",
                            border: currentImageIndex === imgIndex ? "2px solid blue" : "none",
                          }}
                          onClick={() => handleImageClick(palletIndex, imgIndex)}
                        />
                        <div style={{ marginTop: "5px" }}>
                          <Button
                            variant="contained"
                            color="primary"
                            disabled={imgIndex === 0} // Disable "Move Up" for the first image
                            onClick={() => handleMoveImage(palletIndex, imgIndex, -1)}
                            style={{ marginRight: "5px" }}
                          >
                            Up
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            disabled={imgIndex === images[palletIndex].length - 1} // Disable "Move Down" for the last image
                            onClick={() => handleMoveImage(palletIndex, imgIndex, 1)}
                          >
                            Down
                          </Button>
                        </div>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => handleDeleteImage(palletIndex, imgIndex)}
                          style={{
                            marginTop: "5px",
                            backgroundColor: "red",
                            color: "white",
                            fontSize: "10px",
                          }}
                        >
                          x
                        </Button>
                      </div>
                    ))}
                  </div>

                            
                  {images[palletIndex]?.length > 0 && (
                    <Dialog
                      open={showCropper && activePalletIndex === palletIndex}
                      onClose={() => setShowCropper(false)} // Close the popup
                      fullWidth
                      maxWidth="sm"
                    >
                      <DialogTitle>Image Editor</DialogTitle>
                      <DialogContent>
                        <div
                          style={{
                            position: "relative",
                            height: "400px",
                            width: "100%",
                          }}
                        >
                          <Cropper
                            image={images[palletIndex][currentImageIndex]}
                            crop={crop}
                            zoom={zoom}
                            aspect={1}
                            rotation={rotation}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onCropComplete={onCropComplete}
                          />
                        </div>

                        <div>
                          <h4>Rotation</h4>
                          <Slider
                            value={rotation}
                            onChange={(e, newValue) => setRotation(newValue)}
                            min={0}
                            max={360}
                          />
                        </div>

                        <div>
                          <h4>Zoom</h4>
                          <Slider
                            value={zoom}
                            min={1}
                            max={3}
                            step={0.1}
                            onChange={(e, newZoom) => setZoom(newZoom)}
                          />
                        </div>
                      </DialogContent>

                      <DialogActions>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            handleSaveCroppedImage(palletIndex, currentImageIndex);
                            setShowCropper(false); // Close the popup after saving
                          }}
                        >
                          Save Cropped Image
                        </Button>
                        <Button
                          variant="outlined"
                          color="secondary"
                          onClick={() => setShowCropper(false)} // Close the popup without saving
                        >
                          Cancel
                        </Button>
                      </DialogActions>
                    </Dialog>
                  )}


                          </div>
                         
                          <div className="col-md-1">
                            <button
                              className="btn btn-danger"
                              // style={{ marginTop: 30 }}
                              type="button"
                             // onClick={() => arrayHelpers.remove(palletIndex)}
                              // onClick={() => {
                              //   arrayHelpers.remove(palletIndex)
                              // }}
                              onClick={() =>{
                                let item_record = formik.values.pallets[palletIndex];
                                console.log(item_record);
                                if(item_record.id == undefined){
                                  arrayHelpers.remove(palletIndex)
                                  deleteItemFromDB(item_record.token_number);
                                  console.log('IFFFF');
                                }else{
                                  console.log('else');
                                  arrayHelpers.remove(palletIndex)
                                }
                              } }
                            >
                              -
                            </button>
                            {palletIndex === formik.values.pallets.length - 1 && (
                              <div>
                        <button  
                          className="btn btn-primary mb-3"
                          type="button"
                          //style={{paddingTop:'30px;'}}
                          onClick={() => {
                            //let appendArr = arrayHelpers.form.values.pallets[0];
                            let appendArr_1 = arrayHelpers.form.values.pallets && arrayHelpers.form.values.pallets[0];

                            let product_name = (appendArr_1 && appendArr_1.product) ? appendArr_1.product : "";
                            let temperature_name = (appendArr_1 && appendArr_1.temperature) ? appendArr_1.temperature : "";
                            let size_name = (appendArr_1 && appendArr_1.size) ? appendArr_1.size : "";
                            let sample_weight_name = (appendArr_1 && appendArr_1.sample_weight) ? appendArr_1.sample_weight : "";
                            let class_name = (appendArr_1 && appendArr_1.class) ? appendArr_1.class : "";
                            let box_net_weight_name = (appendArr_1 && appendArr_1.box_net_weight) ? appendArr_1.box_net_weight : "";
                            
                            let packaging_name = (appendArr_1 && appendArr_1.packaging) ? appendArr_1.packaging : "";
                            let lot_number_name = (appendArr_1 && appendArr_1.lot_number) ? appendArr_1.lot_number : "";
                            let number_of_boxes_name = (appendArr_1 && appendArr_1.number_of_boxes) ? appendArr_1.number_of_boxes : "";
                            let palletesation_name = (appendArr_1 && appendArr_1.palletesation) ? appendArr_1.palletesation : "";
                            let country_name = (appendArr_1 && appendArr_1.country) ? appendArr_1.country : "";
                            let label_conformity_name = (appendArr_1 && appendArr_1.label_conformity) ? appendArr_1.label_conformity : "";
                           let token_number = Math.floor(Math.random() * 10000000000000)
                                          
                            let initialArr = {
                              product:product_name,
                              temperature: temperature_name,
                              size: size_name,
                              sample_weight: sample_weight_name,
                              class: class_name,
                              box_net_weight: box_net_weight_name,

                              packaging: packaging_name,
                              lot_number: lot_number_name,
                              number_of_boxes: number_of_boxes_name,
                              palletesation: palletesation_name,
                              country: country_name,
                              label_conformity: label_conformity_name,
                              token_number: token_number,
                              pictures:[]
                            };


                            //console.log('Submit button here 2');
                            let newpost= {
                              season_id: season_id,
                              id: formik.values.id,
                              order: formik.values.order,
                              sender: formik.values.sender,
                              customer: formik.values.customer,
                              transport: formik.values.transport,
                              transport_number: formik.values.transport_number,
                              product: formik.values.product,
                              ref: formik.values.ref,
                              date: formik.values.date,
                              pallets: []
                            }
                            //newpost.pallets[] =formik.values.pallets[palletIndex]; 
                           // Ensure palletIndex is defined and valid
                              if (palletIndex >= 0 && palletIndex < formik.values.pallets.length) {
                                newpost.pallets.push(formik.values.pallets[palletIndex]); // Add the specific pallet
                              }
                              $("#pallet-number").removeClass('loader-hide');
                              $("#pallet-number").addClass('loader-show');
                            
                             // console.log(newpost);

                            axios
                            .post("/quality-report/add", newpost, {
                              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                            })  .then((response) => {
                              if (response.data.code === 200) {

                                $("#pallet-number").addClass('loader-hide');
                                $("#pallet-number").removeClass('loader-show');
                                
                                var currentbarcode = formik.values.pallets[palletIndex].pallet_barcode;
                                var currentbarcodeArray =[
                                  {
                                    'value':currentbarcode,
                                    'label':currentbarcode,
                                  }
                                ];
                                console.log(currentbarcodeArray);
                               
                            arrayHelpers.push(initialArr);
                            //formik.values.id = response.data.data.report.id;
                            formik.setFieldValue('id', response.data.data.report.id); // Correct way to set the Formik field

                            //setShowTableHeadings(true);
                           // console.log(formik.values);

                              } else if (response.data.code === 422) {
                                  setBackendErrors(response.data.error);
                                  
                                $("#pallet-number").addClass('loader-hide');
                                $("#pallet-number").removeClass('loader-show');

                              }
                              else if (response.data.code === 401) {
                                setBackendErrors(response.data.error);
                                
                                $("#pallet-number").addClass('loader-hide');
                                $("#pallet-number").removeClass('loader-show');

                              }
                              else {
                                  setBackendErrors(response.data.error);
                                  
                                $("#pallet-number").addClass('loader-hide');
                                $("#pallet-number").removeClass('loader-show');

                              }
                            })
                          }}
                          >
                          +
                          <img  id="pallet-number" className="loader-image loader-hide" src={loader_image}/> 
                          </button>
                              </div>
                          
                            )}
                          </div>
                        </div>
                      </div>
                      )

                    })}
                  </div>
                )}
              />
              <div className="text-end mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={formik.isSubmitting}
                >
                  Add Quality Report
                </button>
              </div>
            </form>
          </FormikProvider>
       
              )}
       </div>
      </div>
    </div>
  );
};

export default QualityReportsAdd;